<template>
  <b-table striped hover :items="result['filter']" class="mt-2" @row-clicked="a => $emit('clickTable',a)"></b-table>
</template>

<script>
export default {
  name: 'FilterResult',
  props: ['result'],
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FilterResult.vue